import React from 'react'
import { Flex, Text } from '@chakra-ui/react'
import { CloseIcon } from '@chakra-ui/icons'
import { useResponsive } from '@common/hooks'
import useFilterQueryParams from '@common/hooks/use-filter-query-param'
import { FilterQueryParams } from '@constants/filter.constant'
import { MapDataFilter } from './shop-filter'

interface FilterTagItemPropsType {
  query: string
  name: string
  filterTags?: MapDataFilter[]
}

const FilterTagItem = ({ query, name, filterTags }: FilterTagItemPropsType) => {
  const { removeQuery } = useFilterQueryParams()

  const queryTags = query.split(',')

  const tags: string[] = []

  if (filterTags != null) {
    for (let i = 0; i < queryTags.length; i++) {
      const handleQuery = queryTags[i]
      const filterTag = filterTags.find(
        (ft) => ft.handle.toLocaleLowerCase() === handleQuery
      )
      if (filterTag != null) {
        tags.push(filterTag.title)
      }
    }
  }

  return (
    <Flex
      bg={'bg'}
      py={2}
      px={3}
      alignItems={'center'}
      gap={8}
      borderRadius={5}
      justifyContent={'space-between'}
    >
      <Flex>
        <Text textStyle={'textTag'}>
          {tags.length > 0 ? tags.join(' | ') : queryTags.join(' | ')}
        </Text>
      </Flex>
      <Flex>
        <CloseIcon
          boxSize={2}
          cursor={'pointer'}
          onClick={() => {
            removeQuery(name)
          }}
        />
      </Flex>
    </Flex>
  )
}

interface FilterTagProps {
  filterCategories: MapDataFilter[]
  filterBrands: MapDataFilter[]
  filterCollections: MapDataFilter[]
  filterSort: MapDataFilter[]
}

const FilterTag: React.FC<FilterTagProps> = ({
  filterCategories,
  filterBrands,
  filterCollections,
  filterSort
}) => {
  const { smMax } = useResponsive()
  const { brands, categories, collections, sort, search, all } =
    useFilterQueryParams()

  return (
    <Flex mt={5} w={'60%'} flexDirection={smMax ? 'column' : 'row'} gap={2}>
      {brands != null && (
        <FilterTagItem
          query={brands as string}
          name={FilterQueryParams.BRANDS}
          filterTags={filterBrands}
        />
      )}
      {categories != null && (
        <FilterTagItem
          query={categories as string}
          name={FilterQueryParams.CATEGORIES}
          filterTags={filterCategories}
        />
      )}
      {collections != null && (
        <FilterTagItem
          query={collections as string}
          name={FilterQueryParams.COLLECTIONS}
          filterTags={filterCollections}
        />
      )}
      {sort != null && (
        <FilterTagItem
          query={sort as string}
          name={FilterQueryParams.SORT}
          filterTags={filterSort}
        />
      )}
      {search != null && (
        <FilterTagItem query={search} name={FilterQueryParams.SEARCH} />
      )}
      {all != null && (
        <FilterTagItem
          query={'All products in one page'}
          name={FilterQueryParams.ALL}
        />
      )}
    </Flex>
  )
}

export default FilterTag
